/**
 * This page handles OAuth callbacks for native mobile apps.
 * 
 * Flow:
 * 1. Native app opens OAuth in external browser via @capacitor/browser
 * 2. After auth, Supabase redirects to this page with tokens in the URL hash
 * 3. This page redirects to the app's deep link scheme (translatify://) with the tokens
 * 4. The app's deep link handler (useDeepLinking) captures the tokens and sets the session
 */
import { useEffect } from 'react';
import { Loader2 } from 'lucide-react';

const NativeAuthCallback = () => {
  useEffect(() => {
    const hash = window.location.hash;
    console.log('[NativeAuthCallback] Hash:', hash);

    if (hash) {
      // Redirect to the app's deep link scheme with the OAuth tokens
      const deepLinkUrl = `translatify://oauth${hash}`;
      console.log('[NativeAuthCallback] Redirecting to deep link:', deepLinkUrl);
      window.location.href = deepLinkUrl;
    } else {
      // No hash - might be an error or the tokens are in query params
      const params = window.location.search;
      if (params) {
        const deepLinkUrl = `translatify://oauth${params}`;
        console.log('[NativeAuthCallback] Redirecting to deep link with query:', deepLinkUrl);
        window.location.href = deepLinkUrl;
      } else {
        console.error('[NativeAuthCallback] No tokens found in URL');
      }
    }
  }, []);

  return (
    <div className="safe-area-screen flex flex-col items-center justify-center bg-background gap-4">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
      <p className="text-muted-foreground">Completing sign in...</p>
      <p className="text-xs text-muted-foreground">Redirecting back to the app...</p>
    </div>
  );
};

export default NativeAuthCallback;
